import React, { useState } from "react";
import ProductBanner from "../../components/pageProps/shopPage/ProductBanner";
import AllProducts from "../../components/pageProps/shopPage/AllProducts";

const Shop = () => {
  const [itemsPerPage, setItemsPerPage] = useState(12); // Set reasonable limit
  const [selectedCategory, setSelectedCategory] = useState("");
  const [productType] = useState("bag"); // Set productType to 'bag' for bags page
  // const itemsPerPageFromBanner = (itemsPerPage) => {
  //   setItemsPerPage(itemsPerPage);
  // };

  return (
    <div className="max-w-container mx-auto px-4">
      {/* <ProductBanner itemsPerPageFromBanner={itemsPerPageFromBanner} /> */}
      <div className="w-full h-full flex pb-20 gap-10 relative">
        <div className="w-full h-full flex flex-col gap-4">
          <AllProducts
            itemsPerPage={itemsPerPage}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            productType={productType}
          />
        </div>
      </div>
    </div>
  );
};

export default Shop;
